import React from "react";
import usePortfolioStyles from "./portfolio-style";
import {useHistory} from "react-router-dom";
import getFormattedDateRange from "../../utils/formatted-date-range";

const CorpSubsidiary = ({subsidiary, subsidiaryIndex, policyIndex, props, policyDetail}) => {
    const classes = usePortfolioStyles(props);
    const history = useHistory();

    const clickPlan = (plan, planIndex) => {
        let policy = {
            policyNumber: plan.policyNumber,
            subsidiaryNo: subsidiary.subsidiaryNo,
            subsidiaryName: subsidiary.subsidiaryName,
            planId: plan.planId,
            planName: plan.planName,
            period: getFormattedDateRange(policyDetail.inceptionDate, policyDetail.expiryDate),
            status: policyDetail.status,
            planIndex: planIndex,
            subsidiaryIndex: subsidiaryIndex,
            policyIndex: policyIndex,
            allowDependent: policyDetail.allowDependent,
            allowAdd: policyDetail.allowAdd ,
            allowModify: policyDetail.allowModify,
            allowDelete: policyDetail.allowDelete
        }
        props.storePolicy(policy);

        let subsidiaryList = policyDetail.subsidiaryList.map(item => ({
            optionValue: item.subsidiaryNo,
            optionLabel: item.subsidiaryName
        }));
        props.storeSubsidiaryList(subsidiaryList);

        let planList = subsidiary.planList.map(item => ({
            optionValue: item.planId,
            optionLabel: item.planName
        }));
        props.storePlanList(planList);

        history.push('/policy')
    }

    return (<>
                <div className={classes.subsidiary_card}>
                    <h2>{subsidiary.subsidiaryName}</h2>
                    <h3>Plans</h3>
                    <div className={classes.plan_links_container}>
                        {
                            subsidiary.planList.length > 0 &&
                            subsidiary.planList.map((plan, index) => {
                                return <a onClick={() => clickPlan(plan, index)}>{plan.planName}</a>
                            })
                        }
                    </div>
                </div>
            </>);
}
export default CorpSubsidiary;
